React = require 'react'
{ PropTypes } = React
{ connect } = require 'react-redux'
SelectThing = require '../components/SelectThing'

SelectClassroom = React.createClass
	displayName: 'SelectClassroom'
	propTypes:
		classrooms: PropTypes.array
		feedback: PropTypes.object
		isFetching: PropTypes.bool
		fetchClassrooms: PropTypes.func.isRequired
		reduxFormProps: PropTypes.object
		# Set this to false e.g. in the case of teachers, who aren't able to select a school since they only belong to one.
		requireSchoolId: PropTypes.bool
		selectedSchoolId: PropTypes.number
		selectedClassroomId: PropTypes.number
		fetchClassroom: PropTypes.func.isRequired
		# Set `shouldFetchClassrooms` to false to prevent this component from fetching its own data.  Defaults to true
		shouldFetchClassrooms: PropTypes.bool

	componentWillMount: ->
		@props.fetchClassrooms() unless @props.shouldFetchClassrooms == false
		# A school is required by default.
		@requireSchoolSelection = @props.requireSchoolId == undefined || @props.requireSchoolId

	getClassroomList: ->
		if @props.selectedSchoolId or @requireSchoolSelection
			@filterClassroomsBySchool()
		else
			@props.classrooms

	filterClassroomsBySchool: ->
		@props.classrooms.filter (classroom) => classroom.school_id == @props.selectedSchoolId

	fetchClassroom: (classroom) ->
		if (classroom?.id)
			return @props.fetchClassroom(classroom.id)

	render: ->
		React.createElement(SelectThing, { \
			"disabled": ( @requireSchoolSelection && !@props.selectedSchoolId ),  \
			"feedback": ( @props.feedback ),  \
			"isFetching": ( @props.isFetching ),  \
			"reduxFormProps": ( @props.reduxFormProps ),  \
			"nameField": 'description',  \
			"selectedThingId": ( @props.selectedClassroomId ),  \
			"selectThing": ( @fetchClassroom ),  \
			"thingName": ( 'classroom' ),  \
			"things": ( @getClassroomList() )
		})

module.exports = SelectClassroom



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/components/SelectClassroom.cjsx